import { Link } from "react-router-dom";

const navigation = {
  main: [
    { name: "الرئيسية", href: "/" },
    { name: "من نحن", href: "/aboutUs" },
    { name: "خدماتنا", href: "/ourservices" },
    { name: "اتصل بنا", href: "/contactUs" },
  ],
  social: [
    {
      name: "Facebook",
      href: "#",
      icon: (props: React.SVGProps<SVGSVGElement>) => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path
            fillRule="evenodd"
            d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
            clipRule="evenodd"
          />
        </svg>
      ),
    },
    {
      name: "Twitter",
      href: "#",
      icon: (props: React.SVGProps<SVGSVGElement>) => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
        </svg>
      ),
    },
    {
      name: "LinkedIn",
      href: "#",
      icon: (props: React.SVGProps<SVGSVGElement>) => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path
            fillRule="evenodd"
            d="M19.812 5.418c.861.23 1.538.907 1.768 1.768C21.998 8.746 22 12 22 12s0 3.255-.418 4.814a2.504 2.504 0 0 1-1.768 1.768c-1.56.419-7.814.419-7.814.419s-6.255 0-7.814-.419a2.505 2.505 0 0 1-1.768-1.768C2 15.255 2 12 2 12s0-3.255.417-4.814a2.507 2.507 0 0 1 1.768-1.768C5.744 5 11.998 5 11.998 5s6.255 0 7.814.418ZM15.194 12 10 15V9l5.194 3Z"
            clipRule="evenodd"
          />
        </svg>
      ),
    },
  ],
};

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="bg-[#294BA1E0] text-white mt-4 px-4 sm:px-6 md:px-8"
      aria-labelledby="footer-heading"
    >
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>
      <div className="mx-auto max-w-7xl py-12 md:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {/* Brand and Description */}
          <div className="space-y-6">
            <h1 className="text-2xl sm:text-3xl font-bold text-white tracking-wide text-center md:text-right">
              حجوزاتي
              <span className="text-sm font-normal text-gray-200 block mt-1">
                خدمات النقل والحجز
              </span>
            </h1>
            <p className="text-sm leading-6 text-gray-200 text-center md:text-right">
              نحن نسعى لتقديم أفضل الخدمات وأحدث المعلومات في مجال النقل
              والخدمات اللوجستية
            </p>
            <div className="flex justify-center md:justify-start space-x-6 rtl:space-x-reverse">
              {navigation.social.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="text-gray-200 hover:text-white transition-colors"
                >
                  <span className="sr-only">{item.name}</span>
                  <item.icon className="h-6 w-6" aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links and Contact Info */}
          <div className="grid grid-cols-2 gap-8 sm:grid-cols-2 md:col-span-2">
            {/* Quick Links */}
            <div className="text-center md:text-right">
              <h3 className="text-sm font-semibold leading-6 text-white">
                روابط سريعة
              </h3>
              <ul className="mt-6 space-y-4">
                {navigation.main.map((item) => (
                  <li key={item.name}>
                    <Link
                      to={item.href}
                      className="text-sm leading-6 text-gray-200 hover:text-white transition-colors"
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            {/* Contact Information */}
            <div className="text-center md:text-right">
              <h3 className="text-sm font-semibold leading-6 text-white">
                تواصل معنا
              </h3>
              <ul className="mt-6 space-y-4">
                <li className="text-sm leading-6 text-gray-200">
                  <span className="font-semibold block sm:inline">
                    العنوان:
                  </span>{" "}
                  المملكة العربية السعودية، الرياض
                </li>
                <li className="text-sm leading-6 text-gray-200">
                  <span className="font-semibold block sm:inline">الهاتف:</span>{" "}
                  966552021145+
                </li>
                <li className="text-sm leading-6 text-gray-200">
                  <span className="font-semibold block sm:inline">
                    البريد الإلكتروني:
                  </span>{" "}
                  info@7jozati.com
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col items-center gap-4 sm:flex-row sm:justify-between">
            <p className="text-xs leading-5 text-gray-200 text-center sm:text-right">
              &copy; {currentYear} جميع الحقوق محفوظة.
            </p>
            <div className="flex gap-4">
              <Link
                to="/PrivacyPolicy"
                className="text-xs leading-5 text-gray-200 hover:text-white transition-colors"
              >
                سياسة الخصوصية
              </Link>
              <Link
                to="/TermsAndConditions"
                className="text-xs leading-5 text-gray-200 hover:text-white transition-colors"
              >
                الشروط والأحكام
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
